/** Turn FastAPI / Axios error payloads into a string safe to show in toasts or JSX. */
export function formatApiError(detail, fallback = 'Something went wrong') {
  if (detail == null || detail === '') {
    return fallback;
  }
  if (typeof detail === 'string') {
    return detail;
  }
  if (Array.isArray(detail)) {
    const parts = detail
      .map((item) => {
        if (typeof item === 'string') return item;
        if (item && typeof item === 'object') {
          const msg = item.msg || item.message || '';
          const loc = Array.isArray(item.loc)
            ? item.loc.filter((part) => part !== 'body' && part !== 'query').join('.')
            : '';
          if (msg && loc) return `${loc}: ${msg}`;
          return msg;
        }
        return '';
      })
      .filter(Boolean);
    return parts.join('. ') || fallback;
  }
  if (typeof detail === 'object') {
    if (typeof detail.msg === 'string') return detail.msg;
    if (typeof detail.message === 'string') return detail.message;
    if (typeof detail.detail === 'string') return detail.detail;
  }
  return fallback;
}

export function formatAxiosError(error, fallback = 'Something went wrong') {
  const data = error?.response?.data;
  return formatApiError(data?.detail ?? data?.message ?? error?.message, fallback);
}
